import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "../../../atom/Dropdown/Dropdown";
import clsx from "clsx";
import { CheckIcon } from "../../../../icons";
import { useState } from "react";
import RepeatIcon from "../../../atom/icons/RepeatIcon";
import { RepeatDropdownOptions, RepeatDropdownOptionsType } from "../../../../types/block/enum";
import { TOOLTIP_LABELS } from "../../../../constants/block/Recurring";
import Tooltip from "../../../atom/Tooltip";

const RepeatDropdown = ({
  repeatDropdownRef,
  selectedRepeat,
  onValueChange,
}: {
  repeatDropdownRef: React.RefObject<HTMLDivElement>;
  selectedRepeat: RepeatDropdownOptionsType | null;
  onValueChange: (value: RepeatDropdownOptionsType) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEscapeKeyDown = (e: KeyboardEvent) => {
    e.stopPropagation();
  };

  const handleDropdownItemKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      e.stopPropagation();
    }
  };

  return (
    <DropdownMenu
      modal={false}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Tooltip
        content={selectedRepeat ? TOOLTIP_LABELS[selectedRepeat] : "Repeat"}
        isShow={isOpen ? false : undefined}
        side="top"
      >
        <DropdownMenuTrigger asChild>
          <button
            className={clsx(
              "flex cursor-pointer select-none items-center justify-center rounded-[5px] bg-transparent p-[4px] text-80",
              "hover:bg-w-8-hover hover:text-white",
              {
                "bg-w-8-hover": isOpen,
                "bg-w-16": selectedRepeat !== null,
              }
            )}
          >
            <RepeatIcon />
          </button>
        </DropdownMenuTrigger>
      </Tooltip>

      <DropdownMenuContent
        ref={repeatDropdownRef}
        width="170px"
        sideOffset={5}
        align="start"
        className="w-[170px] text-white"
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
        onEscapeKeyDown={handleEscapeKeyDown}
      >
        <DropdownMenuRadioGroup
          value={selectedRepeat || ""}
          onValueChange={(value) => onValueChange(value as RepeatDropdownOptionsType)}
        >
          {Object.values(RepeatDropdownOptions).map((option) => (
            <DropdownMenuRadioItem
              key={option}
              value={option}
              onKeyDown={handleDropdownItemKeyDown}
              className={clsx(
                "box-border flex h-8 w-full cursor-pointer items-center justify-between gap-[6px] px-2 text-[12px] text-80 data-[highlighted]:bg-w-8-hover data-[highlighted]:outline-none",
                selectedRepeat === option
                  ? "text-white data-[highlighted]:text-white"
                  : "text-white hover:text-white data-[highlighted]:text-white"
              )}
            >
              <CheckIcon
                color={selectedRepeat === option ? "white" : "transparent"}
                className="text-[14px]"
              />
              <p className="flex-1">{option}</p>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RepeatDropdown;
